import { FaStar } from 'react-icons/fa';

import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import Props from '@/components/shared/components/icon/star/type';

import ICON_SIZE from '@/constant/icon-size-color';
import localization from '@/constant/localization';

export default function StarWithRateCount({
  value = 0,
  textSize = SIZE_ENUM.SM,
  textClassName,
  textWrapperClassName,
  iconSize = ICON_SIZE.sm,
  rateCount = 0,
}: Props) {
  return (
    <Container center className='gap-1.5'>
      <FaStar color='#FEA000' size={iconSize} />
      <Container center className={cn(textWrapperClassName)}>
        <Text size={textSize} className={cn('text-[#878F9B]', textClassName)}>
          {value}
        </Text>

        {rateCount > 0 && (
          <Text className='leading-4 text-[#878F9B]' size={SIZE_ENUM.XS}>
            {localization.outOf} {rateCount} {localization.vote}
          </Text>
        )}
      </Container>
    </Container>
  );
}
